<template>
  <div>
    <model-table
      ref="table"
      :dialog="dialog"
      :collection="users"
      :columns="columns"
      sort-by="createdAt"
      :descending="true"

      :show-add="false"
      :show-edit="false"
      @row-clicked="clicked"
    >
      <template
        #header-controls
      >
        <div
          class="q-mt-xs"
        >
          <q-btn-toggle
            v-model="userRole"
            class="q-my-xs"
            size="sm"
            outline
            toggle-color="primary"
            :options="filters"
          />
        </div>
      </template>
      <user-form v-if="showUserForm" />
    </model-table>
  </div>
</template>

<script>
import ModelTable from 'src/modules/admin/components/ModelTable'
import QueryEncodableOptionsMixin from 'src/modules/admin/mixins/QueryEncodableOptionsMixin'
import UserForm from 'src/modules/admin/user/UserForm'

export default {
  name: 'UserTable',
  components: {
    ModelTable,
    UserForm
  },
  mixins: [QueryEncodableOptionsMixin],
  context: ['currentUser'],
  models: {
    users: {
      membership: {
        currentMembershipInterval: {
          fields: ['amount']
        },
        owner: {
          fields: ['id']
        }
      },
      membershipType: 'default',
      membershipTier: 'default',
      countOfMovies: true,
      userClass: 'default',
      card: 'default',
      userStripeCustomers: 'default',
      variables () {
        return {
          userRole: this.userRole === 'all' ? null : this.userRole,
          noCount: true
        }
      },
      immediate: false
    }
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: false
    },
    showAllFilter: {
      type: Boolean,
      required: false,
      default: true
    },
    showUsersFilter: {
      type: Boolean,
      required: false,
      default: true
    },
    showEmployeesFilter: {
      type: Boolean,
      required: false,
      default: true
    },
    showInvoiceableFilter: {
      type: Boolean,
      required: false,
      default: true
    },
    showMemberColumns: {
      type: Boolean,
      required: false,
      default: true
    },
    showInvoiceColumns: {
      type: Boolean,
      required: false,
      default: false
    },
    showUserForm: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ['select-user'],
  data () {
    return {
      userRole: 'users'
    }
  },
  computed: {
    defaultQueryEncodableOptions () {
      return {
        // from initial data
        userRole: 'users'
      }
    },
    filters () {
      const filters = []

      if (this.showAllFilter) filters.push({ label: 'All', value: 'all' })
      if (this.showUsersFilter) filters.push({ label: 'Users', value: 'users' })
      if (this.showInvoiceableFilter) filters.push({ label: 'Invoiceable', value: 'invoiceable' })
      if (this.showEmployeesFilter) filters.push({ label: 'Employees', value: 'employees' })

      return filters
    },
    columns () {
      let columns = [
        { field: 'id' },
        { name: 'photo', field: 'photoSmallUrl', component: 'img' },
        { field: 'firstName' },
        { field: 'lastName', classes: 'sensitive-column' },
        { field: 'email', classes: 'sensitive-column' },
        { field: 'phone' }
      ]

      if (this.showMemberColumns && this.userRole !== 'invoiceable') {
        columns = _.concat(columns, [
          { name: 'User Class', field: user => user.userClass ? user.userClass.name : null, component: 'chip' },
          { name: 'Membership Type', field: user => user.membershipType ? user.membershipType.name : null, component: 'chip' },
          { name: 'Membership Tier', field: user => user.membershipTier ? user.membershipTier.name : null, component: 'chip' },
          { name: 'Membership State', field: user => user.stateIcon, component: 'icon' },
          { name: 'Member Card', field: user => user.card ? 'credit_card' : '', component: 'icon' },
          { name: 'Saved Payment', field: user => user.defaultPaymentMethodId ? 'payments' : '', component: 'icon' },
          { field: 'countOfMovies', label: 'Movies Watched' }
        ])
      }

      if (this.showInvoiceColumns || this.userRole === 'invoiceable') {
        columns = _.concat(columns, [
          { name: 'Company', field: 'companyName', classes: 'sensitive-column' }
        ])
      }

      columns = _.concat(columns, [
        { name: 'createdAt', field: row => row.createdAt.i18n('timestamp'), component: 'date-time' },
        { name: 'selectedAt', field: row => row.selectedAt ? row.selectedAt.i18n('timestamp') : null, component: 'date-time' },
        { name: 'actions', align: 'right' }
      ])

      return columns
    }
  },
  methods: {
    decodeUrlParamOption (key, value) {
      switch (key) {
        case 'userRole':
          return _.includes(_.map(this.filters, 'value'), value) ? value : undefined
        default:
          return undefined
      }
    },
    show () {
      this.$refs.table.show()
    },
    hide () {
      this.$refs.table.close()
    },
    clicked (user) {
      this.$emit('select-user', user)
    }
  }
}
</script>
